/* AMEIKO — global theme behaviour.
   Every module queries first and no-ops when its elements are absent, so a
   missing section can never take down the rest of the page. */
(function () {
  'use strict';

  var root = document.documentElement;
  var config = window.AmeikoConfig || {};
  var routes = config.routes || {};
  var strings = config.strings || {};

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(config.locale || 'en', {
        style: 'currency',
        currency: config.currency || 'USD'
      }).format(value);
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  /* ---------------------------------------------------------------- toast */

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 3200);
  }

  /* --------------------------------------------------------------- drawers */

  var openDrawer = null;
  var lastFocused = null;

  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (node) { return node.offsetParent !== null || node === document.activeElement; });
  }

  function drawerOpen(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose(openDrawer.id);
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var scrim = $('[data-scrim]');
    if (scrim) scrim.classList.add('is-open');
    root.style.overflow = 'hidden';
    openDrawer = el;
    var first = focusables(el)[0];
    if (first) setTimeout(function () { first.focus(); }, 60);
    $$('[data-drawer-target="' + id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function drawerClose(id) {
    var el = id ? document.getElementById(id) : openDrawer;
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('[data-drawer-target="' + el.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    if (openDrawer === el) openDrawer = null;
    if (!openDrawer) {
      var scrim = $('[data-scrim]');
      if (scrim) scrim.classList.remove('is-open');
      root.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-target]');
    if (opener) {
      event.preventDefault();
      var id = opener.getAttribute('data-drawer-target');
      if (openDrawer && openDrawer.id === id) drawerClose(id);
      else drawerOpen(id);
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      drawerClose(closer.getAttribute('data-drawer-close') || null);
      return;
    }
    if (event.target.closest('[data-scrim]')) drawerClose(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (openDrawer) { drawerClose(null); return; }
      var inMenu = document.activeElement && document.activeElement.closest
        ? document.activeElement.closest('.header__item--has-menu')
        : null;
      if (inMenu) {
        /* The dropdown is held open by :focus-within, so dropping focus
           is what closes it. */
        document.activeElement.blur();
        return;
      }
      var search = $('[data-search-panel].is-open');
      if (search) closeSearch();
      return;
    }
    if (event.key !== 'Tab' || !openDrawer) return;
    var items = focusables(openDrawer);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.AmeikoDrawer = { open: drawerOpen, close: drawerClose };

  /* ---------------------------------------------------------------- header */

  (function header() {
    var wrap = $('[data-header]');
    if (!wrap) return;
    var transparent = wrap.getAttribute('data-transparent') === 'true';
    if (!transparent) return;
    var threshold = 80;
    var ticking = false;

    function apply() {
      ticking = false;
      var y = window.pageYOffset || root.scrollTop || 0;
      wrap.classList.toggle('header--transparent', y <= threshold);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }
    on(window, 'scroll', onScroll, { passive: true });
    apply();
  })();

  /* --------------------------------------------------------- search panel */

  var searchAbort = null;

  function closeSearch() {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    panel.classList.remove('is-open');
    var results = $('[data-search-results]', panel);
    if (results) results.innerHTML = '';
    $$('[data-search-toggle]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
  }

  (function search() {
    var panel = $('[data-search-panel]');
    var toggles = $$('[data-search-toggle]');
    if (!panel || !toggles.length) return;
    var input = $('[data-search-input]', panel);
    var results = $('[data-search-results]', panel);

    toggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      on(btn, 'click', function (event) {
        event.preventDefault();
        var isOpen = panel.classList.toggle('is-open');
        toggles.forEach(function (b) { b.setAttribute('aria-expanded', String(isOpen)); });
        if (isOpen && input) setTimeout(function () { input.focus(); }, 120);
        if (!isOpen && results) results.innerHTML = '';
      });
    });

    if (!input || !results || !routes.predictive_search_url) return;

    var timer = null;
    on(input, 'input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () { fetchSuggestions(term); }, 260);
    });

    function fetchSuggestions(term) {
      if (searchAbort) searchAbort.abort();
      searchAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = routes.predictive_search_url +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,article' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';
      fetch(url, { signal: searchAbort ? searchAbort.signal : undefined })
        .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var payload = doc.querySelector('[data-predictive-body]');
          results.innerHTML = payload ? payload.innerHTML : '';
        })
        .catch(function () { /* silent — the plain search form still works */ });
    }
  })();

  /* ------------------------------------------------------- mobile submenus */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var panel = toggle.parentElement ? toggle.parentElement.nextElementSibling : null;
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* ------------------------------------------------------- scroll reveal */

  (function reveal() {
    var nodes = $$('[data-reveal]');
    if (!nodes.length || reduceMotion.matches || !('IntersectionObserver' in window)) return;
    var viewport = window.innerHeight || 800;
    var armed = nodes.filter(function (node) {
      return node.getBoundingClientRect().top > viewport * 0.9;
    });
    if (!armed.length) return;
    armed.forEach(function (node) {
      var delay = node.getAttribute('data-reveal-delay');
      if (delay) node.style.setProperty('--reveal-delay', delay + 'ms');
      node.classList.add('js-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    armed.forEach(function (node) { io.observe(node); });
  })();

  /* ------------------------------------------------------------ parallax */

  (function parallax() {
    var nodes = $$('[data-parallax]');
    if (!nodes.length || reduceMotion.matches) return;
    var ticking = false;

    function frame() {
      ticking = false;
      var vh = window.innerHeight || 800;
      nodes.forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var target = node.querySelector('.parallax-img') || node;
        var progress = (vh - rect.top) / (vh + rect.height);
        var shift = (progress - 0.5) * -12;
        target.style.transform = 'translate3d(0,' + shift.toFixed(2) + '%,0)';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });
    frame();
  })();

  /* -------------------------------------------------- announcement ticker */

  (function announcements() {
    $$('[data-announcement]').forEach(function (bar) {
      var slides = $$('.announcement__slide', bar);
      var speed = parseInt(bar.getAttribute('data-speed'), 10);
      if (slides.length < 2 || !speed) return;
      var index = 0;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === 0); });
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed * 1000);
    });
  })();

  /* ------------------------------------------------------ quantity steppers */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap ? $('input', wrap) : null;
    if (!input) return;
    event.preventDefault();
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------- cart */

  function updateCartCounts(count) {
    $$('[data-cart-count]').forEach(function (node) { node.textContent = count; });
  }

  function refreshCart(openAfter) {
    var drawer = document.getElementById('CartDrawer');
    var cartUrl = routes.cart_url || '/cart';
    var jobs = [fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateCartCounts(cart.item_count); })
      .catch(function () {})];

    if (drawer) {
      jobs.push(fetch(cartUrl + '?section_id=cart-drawer')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-body]');
          var target = $('[data-cart-drawer-body]', drawer);
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () {}));
    }

    return Promise.all(jobs).then(function () {
      if (openAfter && drawer) drawerOpen('CartDrawer');
    });
  }

  window.AmeikoCart = { refresh: refreshCart, toast: toast, money: money };

  function addToCart(payload, button) {
    if (button) { button.classList.add('loading'); button.setAttribute('aria-busy', 'true'); }
    return fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          toast(result.data.description || result.data.message || strings.cart_error);
          return null;
        }
        if (config.cartType === 'page') {
          window.location.href = routes.cart_url || '/cart';
          return null;
        }
        return refreshCart(true);
      })
      .catch(function () { toast(strings.cart_error); })
      .then(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-busy'); }
      });
  }

  window.AmeikoAddToCart = addToCart;

  /* Quick add straight from a product card. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    event.preventDefault();
    addToCart({ items: [{ id: Number(id), quantity: 1 }] }, btn);
  });

  /* Cart line quantity + removal (drawer and cart page share this). */
  function changeLine(key, quantity, context) {
    var body = context ? context.closest('[data-cart-drawer-body], [data-cart-page]') : null;
    if (body) body.classList.add('loading');
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
      .then(function () {
        var page = $('[data-cart-page]');
        if (page) { window.location.reload(); return; }
        return refreshCart(false);
      })
      .catch(function () { toast(strings.cart_error); })
      .then(function () { if (body) body.classList.remove('loading'); });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(remove.getAttribute('data-cart-remove'), 0, remove);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(input.getAttribute('data-cart-qty'), qty, input);
  });

  /* Cart note — saved on blur, never blocks anything. */
  document.addEventListener('change', function (event) {
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    fetch((routes.cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () {});
  });

  /* ------------------------------------------------------- localization */

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-locale-select]');
    if (!select) return;
    var form = select.closest('form');
    if (form) form.submit();
  });

  /* ------------------------------------------------------------ galleries */

  $$('[data-gallery]').forEach(function (gallery) {
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (slides.length < 2 || !thumbs.length) return;

    function show(index) {
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
    }
    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function () { show(i); });
    });
    show(0);
  });

  window.AmeikoGallery = {
    showMedia: function (mediaId) {
      $$('[data-gallery]').forEach(function (gallery) {
        var slides = $$('[data-gallery-slide]', gallery);
        var thumbs = $$('[data-gallery-thumb]', gallery);
        var index = -1;
        slides.forEach(function (slide, i) {
          if (slide.getAttribute('data-media-id') === String(mediaId)) index = i;
        });
        if (index < 0) return;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
      });
    }
  };
})();
